import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCursorClick24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCursorClick24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.3 9.825a4.919 4.919 0 1 0-5.496 5.472l.383 1.534a6.418 6.418 0 1 1 6.646-6.597zm-4.528 2.561q-.173.031-.354.032a2 2 0 1 1 1.968-1.646l7.059 2.017a.75.75 0 0 1 .089 1.41l-2.992 1.282 3.227 3.227a.75.75 0 1 1-1.06 1.06l-3.228-3.226-1.282 2.992a.75.75 0 0 1-1.41-.09zm4.176 2.147 2.056-.882-4.694-1.34 1.341 4.693.883-2.058.01-.026.113-.263.26-.111z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCursorClick24);
